import appMapProductsAllowed from './appMapProductsAllowed';
import appMapProductSettings from './appMapProductSettings';
import baseMapProductIdsWeb from '../../base/baseMapProductIds';
import baseParameterIds from '../../base/baseParameterIds';

export default (urlParameters) => {
  return {
    allowedMapProducts: appMapProductsAllowed,
    defaultMapProductSettings: appMapProductSettings(),
    mapProductIds: baseMapProductIdsWeb,
    parameterIds: baseParameterIds
  }
}